// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__U2lMb","container":"styles_container__dNFoG"};